import api from "./axios";
import type {
  LogislySpxOnCall,
  LogislySpxOnCallStatisticsResponse,
} from "../types/logislySpxOnCall";
import type { PaginationParam, PaginationResponse } from "../types/paginationResponse";
import { buildPaginationQuery } from "../utils/pagination";
import { mapPaginationResponse } from "../types/paginationResponse";

export interface GetLogislySpxOnCallResponse {
  logislySpxOnCalls: LogislySpxOnCall[];
  pagination: PaginationResponse;
  lastUpdatedAt?: string | null;
}

export const getLogislySpxOnCallApi = async (
  pagination?: PaginationParam,
): Promise<GetLogislySpxOnCallResponse> => {
  try {
    const queryString = buildPaginationQuery(pagination);
    const response = await api.get<any>(`/api/external/logisly/spxOnCall${queryString}`);

    // Extract pagination info from API response
    // API might return pagination in response.data.data.pagination or we construct it from total
    const currentPage = pagination?.page || 1;
    const currentPageSize = pagination?.pageSize || 50;
    const total = Number(response.data.data.total) || 0;

    let apiPagination: PaginationResponse;
    if (response.data.data.pagination) {
      // API returned pagination metadata, use it
      apiPagination = mapPaginationResponse(response.data.data.pagination);
      // Ensure pageSize matches what we requested (in case API doesn't return it)
      if (pagination?.pageSize) {
        apiPagination.pageSize = pagination.pageSize;
      }
    } else {
      // Construct pagination from total and request params
      apiPagination = {
        page: Number(currentPage),
        pageSize: Number(currentPageSize),
        total: total,
        totalPages: Math.ceil(total / currentPageSize),
        sortBy: "",
        sortOrder: "desc",
      };
    }

    return {
      logislySpxOnCalls: response.data.data.logislySpxOnCalls,
      pagination: apiPagination,
      lastUpdatedAt: response.data.data.lastUpdatedAt ?? null,
    };
  } catch (error) {
    console.error("Error fetching Logisly SPX OnCall data:", error);
    throw error;
  }
};

export const getLogislySpxOnCallStatisticsApi = async (
  startDate: string,
  endDate: string,
): Promise<LogislySpxOnCallStatisticsResponse> => {
  try {
    const response = await api.get<LogislySpxOnCallStatisticsResponse>(
      `/api/external/logisly/spxOnCall/statistics?startdate=${startDate}&enddate=${endDate}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Logisly SPX OnCall statistics:", error);
    throw error;
  }
};
